var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1666 5.33301V3.33301L12.1666 1.33301L12.8333 2.66634L14.1666 3.33301L12.1666 5.33301H10.1666ZM10.1666 5.33301L7.49998 7.99964M14.1667 7.99967C14.1667 11.6816 11.1819 14.6663 7.5 14.6663C3.8181 14.6663 0.833336 11.6816 0.833336 7.99967C0.833336 4.31778 3.8181 1.33301 7.5 1.33301M10.8333 7.99967C10.8333 9.84062 9.34095 11.333 7.5 11.333C5.65905 11.333 4.16667 9.84062 4.16667 7.99967C4.16667 6.15873 5.65905 4.66634 7.5 4.66634",
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIcon);
export default __webpack_public_path__ + "static/media/target-icon.f542110ea0a16ebee786e19f8083f70e.svg";
export { ForwardRef as ReactComponent };